var render = function render(){var _vm=this,_c=_vm._self._c;return _c('calendar',{ref:"calendar",staticClass:"d-flex justify-content-center",attrs:{"ajax-url":_vm.ajaxUrl,"date-key":"start","initialDate":"initialDate"},on:{"daySelected":_vm.setDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }